// update state
const setContextConfigurationAction = (payload) => {
    return {
        type: "CONTEXTCONFIGURATION",
        payload
    }
}

export default setContextConfigurationAction;


// WEBPACK FOOTER //
// ./src/actions/setContextConfigurationAction.js